/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, StatusBadge } from '@gsa/afp-component-library';
import CommentReplyList from './comment-replies-list';
import { publishStatusColor } from './helpers';
import '../../comment-admin.scss';

const CommentDetail = ({ props }) => {
  const [showMore, setShowMore] = useState(false);
  const [displayHeader, setDisplayHeader] = useState('');
  const [searchParams, setSearchParams] = useState({});
  const [pathName, setPathName] = useState('');

  useEffect(() => {
    let header = `Fed Standard  ${props.fvsCode}`;
    if (props.linkedEntityType === 'StandardItem') {
      header += ` > Standard Item ${props.linkedEntity?.standardItemNumber}`;
    }
    if (props.linkedEntityType === 'Association') {
      header += ` > Standard Item ${props.linkedEntity?.standardItem?.standardItemNumber} > Equipment Code ${props.linkedEntity?.equipmentCode?.code}`;
    }

    let type = '';
    if (props.linkedEntityType === 'StandardItem') {
      type = 'si';
    } else if (props.linkedEntityType === 'Association') {
      type = 'ec';
    } else {
      type = 'doc';
    }
    setDisplayHeader(header);
    setSearchParams({
      standardItemNumber:
        props.linkedEntity?.standardItem?.standardItemNumber ||
        props.linkedEntity?.standardItemNumber,
      equipmentCode: props.linkedEntity?.equipmentCode?.code,
      fedCode: props.fvsCode,
      year: props.year,
      entityType: type,
      commentId: props.id,
      linkedEntityId: props.linkedEntityId,
    });
  }, [props]);

  const getPathname = () => {
    if (searchParams.entityType === 'si') {
      const queryParams = new URLSearchParams();
      queryParams.set('filter-year', searchParams.year);
      queryParams.set('filter-fedStandardCode', searchParams.fedCode);
      queryParams.set('filter-standardItem', searchParams.standardItemNumber);
      queryParams.set('showCommentTab', 'true');
      return `/public/fvs/vehicle-standards/requirements?${queryParams.toString()}`;
    }
    if (searchParams.entityType === 'ec') {
      const queryParams = new URLSearchParams();
      queryParams.set('filter-year', searchParams.year);
      queryParams.set('filter-fedStandardCode', searchParams.fedCode);
      queryParams.set('filter-standardItem', searchParams.standardItemNumber);
      queryParams.set('code', searchParams.equipmentCode);
      queryParams.set('commentId', searchParams.commentId);
      return `/public/fvs/vehicle-standards/requirements?${queryParams.toString()}`;
    }
    return `/public/fvs/vehicle-standards/preview/${searchParams.year}/${searchParams.linkedEntityId}?showCommentTab=true`;
  };

  useEffect(() => {
    const path = getPathname();
    setPathName(path);
  }, [searchParams]);

  const handleClick = () => {
    const current = showMore;
    setShowMore(!current);
  };

  const expandBtnLabel = !showMore ? 'More' : 'Less';

  const username = () => {
    let authorType = props?.authorType;
    if (authorType === 'VehicleSupplier') {
      authorType = 'Vehicle Supplier';
    }
    return <span className="text-bold margin-top-105">{authorType}</span>;
  };

  return (
    <div className="commentWrapper">
      <Link to={pathName} className="text-primary">
        {displayHeader}
      </Link>
      <br />
      {username()}
      <br />
      <div className="margin-bottom-105 margin-top-105">
        <StatusBadge variant={publishStatusColor[props.publishStatus]}>
          {props.publishStatus}
        </StatusBadge>
      </div>
      <p className={!showMore ? 'comment-container' : null}>{props.comment}</p>
      {props.replies.length && showMore ? (
        <CommentReplyList
          replies={props.replies}
          currentUser={undefined}
          isPublished={props.publishStatus !== 'Unpublished'}
          canManage={false}
        />
      ) : null}
      {props.comment.length > 200 || props.replies.length ? (
        <div className="more-btn">
          <Button
            data-testid="comment-detail-expand-btn"
            variant="unstyled"
            onClick={() => handleClick()}
            label={expandBtnLabel}
            rightIcon={{
              name: !showMore ? 'expand_more' : 'expand_less',
              className: 'usa-icon--size-3',
            }}
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

CommentDetail.propTypes = {};

export default CommentDetail;
